module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073e7_banner_800x600.ec5369f5.png";